import { render } from "./reporteespecificoavance.vue?vue&type=template&id=fb56a4b2"
import script from "./reporteespecificoavance.vue?vue&type=script&lang=js"
export * from "./reporteespecificoavance.vue?vue&type=script&lang=js"

import "./reporteespecificoavance.vue?vue&type=style&index=0&id=fb56a4b2&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__